import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('marketingSmsSignatureStore')
@observer
class MarketingSmsSignature extends Component {
  render() {
    const { marketingSmsSignatureStore, location } = this.props
    const { isFetching } = marketingSmsSignatureStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default MarketingSmsSignature;
